function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("image", {
  id: "image0",
  width: 36,
  height: 41,
  x: 0,
  y: 0,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAApCAMAAABqQHt0AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAANlBMVEUAAAAx0FUx0FUx0FUx 0FUx0FUx0FUx0FUx0FUx0FUx0FUx0FUx0FUx0FUx0FUx0FUx0FX///+uCSUKAAAAEHRSTlMAcO+A 31C/MJ8QQCCPr2DPsKBkzwAAAAFiS0dEEeK1PboAAAAHdElNRQfkCwQWLRnlWXifAAAA+0lEQVQ4 y43U2xaEIAgFUJKmFLvw/187Tpoh5miPrV3iAYXJIHQfZJ4/A4h5WQcQs3UDiM00gEJpNIBCaX4A MW9uADVKU4h5H0HokTooxEp1agWaj/CGfqVhCxm8fkDRf16RTSnRs7JGZ66W8mc5tYjM8fybRAGT QCh3Q8VWKKG9bFmBYkOPXUenUCgNXDWUFeKwnB4QjUIUWA1Iia5QUSdQoNQe1FlKdDc6tyUHQaKY usEpUhIT8TIq8T2JiXgduoUismUsenytJ7mLxowbqA+pRq9nCvVq0ENL4zqQB+EA6CFsX1E32j1A B50E0EF/b7mENtcxsFrfI/AF5KsjfFlgYIcAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjAtMTEtMDRU MjI6NDU6MjUrMDM6MDC/Qt9/AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIwLTExLTA0VDIyOjQ1OjI1 KzAzOjAwzh9nwwAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAAAASUVORK5C YII="
});

var SvgAquilaIconGRight = function SvgAquilaIconGRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "36px",
    height: "41px",
    viewBox: "0 0 36 41",
    enableBackground: "new 0 0 36 41",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAquilaIconGRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/aquila-icon-g-right.b8e8e479.svg";
export { ForwardRef as ReactComponent };